import userInfo from 'hub-http/userInfo';
export async function getCurrentUser() {
  const currentUser = await userInfo();
  return currentUser;
}
export async function refreshCurrentUser() {
  const currentUser = await userInfo({
    cached: false
  });
  return currentUser;
}